<template>
  <dialogue-modal
    v-if="productGroupToDelete"
    title="Are you sure you want to delete?"
    :message="productGroupToDelete.name"
    :close-popup="hideDeleteModal"
    :buttons="buttons"
  />
  <page-title
    pageTitle="Product Price Group"
    title="All Product Price Groups"
  />

  <div class="row pb-4 gy-3">
    <div class="col-sm-4">
      <router-link to="/productGroups/new" class="btn btn-primary addtax-modal">
        <i class="las la-plus me-1"></i> Add New
      </router-link>
    </div>

    <div class="col-sm-auto ms-auto">
      <div class="d-flex gap-3">
        <div class="search-box">
          <input
            type="text"
            class="form-control"
            id="searchMemberList"
            placeholder="Search for Result"
            v-model="searchQuery"
            @input="goToPage(1)"
          />
          <i class="las la-search search-icon"></i>
        </div>
      </div>
    </div>

    <div class="col-sm-auto">
      <div class="d-flex input-group">
        <label class="input-group-text" for="inputGroupSelect01">Show</label>
        <select
          class="form-select"
          id="resultsPerPage"
          v-model="resultsPerPage"
          @change="goToPage(1)"
        >
          <option
            v-for="option in resultsPerPageOptions"
            :key="option"
            :value="option"
          >
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div v-if="data.length > 0" class="">
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <table-component
              :headers="headers"
              :data="data"
              :actions="actions"
              :offset="(currentPage - 1) * resultsPerPage"
              @sort="goToPage"
            />
          </div>
        </div>
      </div>
    </div>
    <pagination-component
      :rows-loaded="data.length"
      :current-page="currentPage"
      :num-pages="numPages"
      :total-rows="totalRows"
      :go-to-page="goToPage"
    />
  </div>

  <div v-else class="row">
    <div class="col-xl-12">
      <div class="card">
        <LoadingModal v-if="loading" />
        <div v-else class="card-body">
          {{ error }}
        </div>
        <div class="gap-2 mt-4 card-body">
          <button
            type="button"
            class="btn btn-light"
            @click="this.$router.go(-1)"
          >
            Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import TableComponent from "@/components/utils/Table";
import { SETTINGS } from "@/constants/config.js";
import { CONSTANTS } from "@/constants/constants.js";
import LoadingModalComponent from "@/components/utils/LoadingModal";
import PaginationComponent from "@/components/utils/paginationComponent";
import DialogueModal from "@/components/utils/modals/DialogueModal";

export default {
  name: "AllProductGroupsView",
  components: {
    DialogueModal,
    PaginationComponent,
    LoadingModal: LoadingModalComponent,
    PageTitle: PageTitleComponent,
    TableComponent: TableComponent,
  },
  data() {
    return {
      searchQuery: "",
      resultsPerPage: SETTINGS.resultsPerPage,
      productGroupToDelete: null,
    };
  },
  computed: {
    headers() {
      return CONSTANTS.PRODUCT_GROUP_HEADERS;
    },
    data() {
      return this.$store.getters.allProductGroups;
    },
    currentPage() {
      return this.$store.getters.productGroupsCurrentPage;
    },
    numPages() {
      return this.$store.getters.productGroupsNumPages;
    },
    totalRows() {
      return this.$store.getters.productGroupsTotalRows;
    },
    resultsPerPageOptions() {
      const options = CONSTANTS.RESULTS_PER_PAGE_OPTIONS;
      if (!options.includes(this.resultsPerPage)) {
        options.unshift(this.resultsPerPage);
      }
      return options;
    },
    actions() {
      return {
        "View/Edit": (productGroup) => this.viewProductGroup(productGroup.id),
        "Group Price Change": (productGroup) =>
          this.editProductGroup(productGroup.id),
        Delete: (productGroup) => this.showDeleteModal(productGroup),
      };
    },
    error() {
      return this.$store.getters.productGroupsError;
    },
    loading() {
      return this.$store.getters.productGroupsLoading;
    },
    buttons() {
      return {
        Yes: {
          class: "btn-danger",
          function: () => this.deleteProductGroup(),
        },
        No: {
          class: "btn-light px-3",
          function: () => this.hideDeleteModal(),
        },
      };
    },
  },
  methods: {
    async goToPage(page, sortBy = null) {
      let filter = {
        sortingList: sortBy,
        currentPage: page,
        resultsPerPage:
          this.resultsPerPage === "ALL" ? this.totalRows : this.resultsPerPage,
        searchQuery: this.searchQuery,
      };
      await this.$store.dispatch("getProductGroups", filter);
    },
    viewProductGroup(id) {
      this.$router.push("/productGroups/" + id);
    },
    editProductGroup(id) {
      this.$router.push("/productGroups/edit/" + id);
    },
    showDeleteModal(productGroup) {
      this.productGroupToDelete = productGroup;
    },
    async deleteProductGroup() {
      if (this.productGroupToDelete) {
        await this.$store.dispatch(
          "deleteProductGroup",
          this.productGroupToDelete.id
        );
        await this.goToPage(1);
        this.hideDeleteModal();
      } else {
        alert("There has been an error");
      }
    },
    hideDeleteModal() {
      this.productGroupToDelete = null;
    },
  },
  async created() {
    let filter = {
      resultsPerPage: SETTINGS.resultsPerPage,
    };
    await this.$store.dispatch("getProductGroups", filter);
  },
  beforeUnmount() {
    console.log("All ProductGroups Destroyed");
  },
};
</script>

<style scoped></style>
